interface UseEmailRegistrationCheckProps {
  email?: string;
  organizationId?: string;
  enabled?: boolean;
}

interface UseEmailRegistrationCheckResult {
  isRegistered: boolean | null; // null = unknown / not checked
  isChecking: boolean;
  error: string | null;
}

/**
 * Previously queried Firestore `webUsers` to auto-switch the squeeze page to
 * login when an email was already registered. There is no Spanner endpoint that
 * answers "is this email registered" for an unauthenticated caller, and the IDX
 * signup endpoint now treats a repeat signup as an idempotent update/link — so
 * the pre-check is no longer needed. This hook is intentionally a no-op that
 * always reports "unknown" (`isRegistered: null`); the squeeze page shows signup
 * and the backend resolves duplicates. Kept as a hook to preserve call sites.
 */
export const useEmailRegistrationCheck = (
  _props: UseEmailRegistrationCheckProps
): UseEmailRegistrationCheckResult => {
  return { isRegistered: null, isChecking: false, error: null };
};

export default useEmailRegistrationCheck;
